import { render, staticRenderFns } from "./GestaoContratosOriginacaoEmpresa.vue?vue&type=template&id=78642e84&lang=pug"
import script from "./GestaoContratosOriginacaoEmpresa.vue?vue&type=script&lang=js"
export * from "./GestaoContratosOriginacaoEmpresa.vue?vue&type=script&lang=js"
import style0 from "./GestaoContratosOriginacaoEmpresa.vue?vue&type=style&index=0&id=78642e84&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports